import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'KisPortas-Admin';

  constructor() {
    this.setTheme();
  }

  private async setTheme(): Promise<void> {
    let storedTheme = 'dark';
    let isDarkMode = storedTheme
      ? storedTheme === 'dark'
      : window.matchMedia('(prefers-color-scheme: dark)').matches;

    document.body.setAttribute('data-theme', isDarkMode ? 'dark' : 'light');
  }
}
